<template>
  <div class="cal-entry-dialog">
    <form novalidate class="md-layout">
      <md-card  style="min-width:450px;">
        <md-card-header>
          <b-row>
            <b-col>
              <div class="md-title">{{propertyTitle}}</div>
            </b-col>
            <b-col style="text-align:right">
              <md-button class="md-icon-button md-dense" @click="onClose">
                <md-icon>highlight_off</md-icon>
              </md-button>
            </b-col>
          </b-row>
        </md-card-header>
        <md-card-content>
          <md-tabs class="white">
            <md-tab id="general-tab" md-label="General">
                <b-row class="mb-3">
            <b-col>
              <md-chip class="md-primary">{{ eventType }}</md-chip>
            </b-col>
            <b-col>
              <md-button v-if="dealId" @click="goToDeal()" class="md-primary m-0">
                <md-icon>bookmarks</md-icon>Go To Deal
              </md-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <md-field>
                <label>Tenant name</label>
                <md-input placeholder="Name" :value="tenantName" disabled></md-input>
              </md-field>
            </b-col>
            <b-col>
              <md-field>
                <label>Tenant surname</label>
                <md-input placeholder="Surname" :value="tenantSurname" disabled></md-input>
              </md-field>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <md-field>
                <label>Disabled</label>
                <md-input v-model="startDate" disabled></md-input>
              </md-field>
            </b-col>
            <b-col>
              <md-field>
                <label>Disabled</label>
                <md-input v-model="endDate" disabled></md-input>
              </md-field>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <md-field>
                <label for="bookingStatus">Entry status</label>
                <md-select v-model="bookingStatus" id="bookingStatus" disabled>
                  <md-option
                    v-for="(status, index) in bookingStatuses"
                    :key="index"
                    :value="status.value"
                  >{{ status.title }}</md-option>
                </md-select>
              </md-field>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <md-field>
                <label>Event Description</label>
                <md-textarea v-model="autoComment" disabled></md-textarea>
              </md-field>
            </b-col>
          </b-row>
            </md-tab>
            <md-tab id="deals-tab" md-label="Deal Notes" :md-disabled="!dealNotesAvailable">
              <!--<md-progress-bar md-mode="indeterminate"></md-progress-bar>-->
              <listing-deal-notes
                v-if="dealNotesAvailable"
                :deal-id="dealId"
                :account-id="selectedAccountId"
              ></listing-deal-notes>
              <p v-else>Notes are not available for this kind of Deal</p>
            </md-tab>
          </md-tabs>
          
        </md-card-content>

        <md-card-actions>
          <md-button class="md-button" @click="onClose">Close</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ListingDealNotes from '@/components/listingDealNotes.vue';

export default {
  name: "ReadonlyEntryDialog",
  components: { ListingDealNotes },
  props: {
    propertyId: {
      type: String,
      required: true
    },
    entryId: {
      type: String,
      required: true
    }
  },
  created() {
    if (!this.entry) {
      return;
    }
    this.startDate = this.entry.startDate
      ? new Date(this.entry.startDate).toDateString()
      : "";
    this.endDate = this.entry.endDate
      ? new Date(this.entry.endDate).toDateString()
      : "";
    this.bookingStatus = this.entry.status;
    this.statusComment = this.entry.statusComment;
    this.tenantName = this.entry.tenantName;
    this.tenantSurname = this.entry.tenantSurname;
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      bookingStatuses: [
        {
          title: "Pre-booked",
          value: "prebooked"
        },
        {
          title: "Booked",
          value: "booked"
        },
        {
          title: "Blocked",
          value: "blocked"
        }
      ],
      bookingStatus: "",
      statusComment: "",
      tenantName: "",
      tenantSurname: ""
    };
  },
  computed: {
    ...mapState({
      activeProperties: state => state.propertiesModule.activeProperties,
      draftProperties: state => state.propertiesModule.draftProperties
    }),
    ...mapState("propertyCalendarModule", ["entries"]),
    property() {
      var res = this.activeProperties.find(
        item => item._id === this.propertyId
      );
      if (res) return res;
      else
        return this.draftProperties.find(item => item._id === this.propertyId);
    },
    entry() {
      return this.entries.find(item => item.id === this.entryId);
    },
    dealId() {
      if (!this.entry || !this.entry.id) {
        return null;
      }
      return this.entry.bookingId;
    },
    systemGeneratedEntry() {
      return this.entry.creatorType === "system";
    },
    eventType() {
      if (this.systemGeneratedEntry) return "Auto event";
      else return "Manual event";
    },
    propertyTitle() {
      if (!this.property || !this.property._id) {
        return null;
      }
      try {
        const {
          location: {
            address: { street, number, apartNumber, municipality } = {}
          } = {}
        } = this.property;

        return `${street} ${number} - ${apartNumber}, ${municipality}`;
      } catch (error) {
        console.log(error);
        return "";
      }
    },
    autoComment() {
      if (this.statusComment) return this.statusComment;
      else if (this.systemGeneratedEntry)
        return "This event was created automatically from the Deal. Visit the deal to see more.";
    },
    dealNotesAvailable() {
      return (
        this.dealId && this.selectedAccountId
      );
    },
    selectedAccountId() {
      return this.$store.getters.connectedAccountIds.length > 0
        ? this.$store.getters.connectedAccountIds[0]
        : null;
    },
    
  },
  methods: {
    goToDeal() {
      if (this.dealId) {
        this.navigateTo({ name: "deal", params: { dealId: this.dealId } });
      }
    },
    navigateTo({ name, params, query }) {
      this.$router.push({
        name: name,
        params: params,
        query: query
      });
    },
    resetData() {
      this.startDate = null;
      this.endDate = null;
      this.bookingStatus = "";
      this.statusComment = "";
      this.tenantName = "";
      this.tenantSurname = "";
    },
    onClose() {
      this.$emit("closed");
      this.resetData();
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/property-calendar/dialogs/ReadonlyEntryDialog.vue